<template lang="pug">
.rules
  managementPage.scrollable(:title="$t(`${baseTranslationPath}.title`)"
                  @fetchData="loadList"
                  :searchPageSize="searchPageSize",
                  @openEditor="openEditor"
                  :showTotals="true"
                  :teamFilter="false"
                  :creationTooltipContent="$t(`${baseTranslationPath}.manage.new`)"
                  :pagination="pagination"
                  ref="managementPage")
      router-view(v-slot:editor)
      template(v-slot:body)
        aiq-table.manage-documents-scrollbar(:data="items" :default-sort="defaultSortOrder" v-loading="loading")
          aiq-table-column(:label="$t(`${baseTranslationPath}.rule_name`)"
                              label-class-name="is-bordered"
                              min-width="40"
                              :sort-method="onSortName"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ scope.row.name }}
          aiq-table-column(prop="created_at"
                          :label="$t(`${baseTranslationPath}.created_at`)"
                          label-class-name="is-bordered"
                          min-width="50"
                          :sortable="true"
                          :sort-method="onSortTime('created_at')")
                template(v-slot:default="scope")
                   span {{ getItemTime(scope.row, 'created_at') }}
          aiq-table-column(prop="completed_at"
                          :label="$t(`${baseTranslationPath}.updated_at`)"
                          label-class-name="is-bordered"
                          min-width="50"
                          :sortable="true"
                          :sort-method="onSortTime('updated_at')")
                template(v-slot:default="scope")
                   span {{ getItemTime(scope.row, 'updated_at') }}
          aiq-table-column(
                          align="center"
                          label-class-name="is-bordered"
                          width="71")
            template(v-slot:default="scope")
              aiq-button(v-if="canView('/settings/smartdrive/rules/edit')" link type="primary" size="small", @click="openEditor(scope.row, 'edit')") {{ $t(`global.edit`) }}
</template>
<script>
import get from 'lodash/get';
import { mapState } from 'vuex';
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';
import { PAGINATION_DEFAULT } from '@/constants/pagination';
import dayjs from '@/localPlugins/dayjs';

const SEARCH_PAGE_SIZE = 25;
export default {
  name: 'Rules',
  components: {
    ManagementPage,
  },
  data() {
    return {
      loading: true,
      pagination: PAGINATION_DEFAULT,
      searchPageSize: SEARCH_PAGE_SIZE,
      defaultSortOrder: { prop: 'updated_at', order: 'descending' },
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.rules_manage',
    };
  },
  computed: {
    ...mapState({
      items: state => state.smartControl.rules,
    }),
  },
  methods: {
    async loadList({ searchTerm, searchOffset }) {
      const params = {
        limit: this.searchPageSize,
        query: searchTerm,
        offset: searchOffset,
      };

      const response = await this.$store.dispatch(
        'smartControl/getRuleList',
        [params, searchOffset === 0],
      );
      this.loading = false;
      this.pagination = get(response, 'data.pagination', PAGINATION_DEFAULT);
      return response;
    },
    getItemTime(item, field) {
      const time = get(item, field, '');
      return dayjs(time).format('YYYY-MM-DD HH:mm A');

    },
    openEditor(record = {}, action = 'edit') {
      const id = get(record, 'id', 'new');
      const path = `${this.$route.path}/${id}`;

      if (action === 'view') {
        this.$router.push({
          path,
          query: {
            view: true,
          },
        });
      } else {
        this.$router.push({
          path,
        });
      }
    },
    onSortName(a, b) {
      const aValue = a.name.toLowerCase().replace(/\s+/g, '');
      const bValue = b.name.toLowerCase().replace(/\s+/g, '');
      return aValue < bValue ? 1 : -1;
    },
    onSortTime(field) {
      return (a, b) => {
        const aVal = get(a, field, '');
        const bVal = get(b, field, '');
        return aVal <= bVal ? 1 : -1;
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.rules {
  height: calc(100vh - 50px);
  overflow-y: auto;
}
</style>